module.exports = __webpack_public_path__ + "media/wilton-greens-is.732aa9ea.jpg";